import { useEffect, useState } from 'react';
import styled from 'styled-components';
import useObservable from '../../hooks/useObservable';
import {Box} from '../../styled';
import PerformanceStore from '../../xstores/performance';
import {forOwn, mapValues, isNumber, floor} from 'lodash';

const TimerRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  
  &.total{
    font-weight: 700;
  }
`

const Timings = () => {
  const pageTimes = useObservable(PerformanceStore.pageTimes$, {});
  const [displayPageTimers, setDisplayPageTimers] = useState([]);
  useEffect(() => {
    const toArray:any = [];
    forOwn(pageTimes, (v) => {
      const { page, ...values } = v;
      toArray.push({
        page,
        ...mapValues(values, (item) => {
          if (isNumber(item)) {
            return floor((item % 60000) / 1000, 2)
          }
          return item;
        })
      })
    });
    setDisplayPageTimers(toArray);
  }, [pageTimes]);

  return (
    <Box>
      {displayPageTimers.map((timer:any) => (
        <Box border="1ps solid #dedede" padding={1} key={timer.page}>
          <p style={{ textAlign: 'center', fontSize:14, margin:0 }}>Page: {timer.page}</p>
          <TimerRow>
            <span>Fetch:</span>
            <span>{timer.request}s</span>
          </TimerRow>
          <TimerRow>
            <span>FE Format:</span>
            <span>{timer.parse}s</span>
          </TimerRow>
          <TimerRow className="total">
            <span>Total:</span>
            <span>{floor(timer.request + timer.parse, 2)}s</span>
          </TimerRow>
        </Box>
      ))}
    </Box>
  )
}

export default Timings;